export default class AbstractModule {
}
